import { makeStyles } from '@material-ui/core/styles';

const useCleaningReportPluginspaceStyles = makeStyles(theme => ({
    liveShell: {
        borderRadius: 12,
        padding: theme.spacing(2, 2.5),
        marginBottom: theme.spacing(3),
        background:
            theme.palette.type === 'dark'
                ? `linear-gradient(135deg, ${theme.palette.grey[900]} 0%, ${theme.palette.grey[800]} 100%)`
                : `linear-gradient(135deg, ${theme.palette.primary.main}08 0%, ${theme.palette.secondary.main}12 100%)`,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow:
            theme.palette.type === 'dark'
                ? '0 4px 24px rgba(0,0,0,0.35)'
                : '0 4px 20px rgba(0,0,0,0.06)',
    },
    liveTitleRow: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1.5),
    },
    liveBadge: {
        animation: '$pulseSoft 2.4s ease-in-out infinite',
    },
    '@keyframes pulseSoft': {
        '0%, 100%': { opacity: 1 },
        '50%': { opacity: 0.72 },
    },
    '@keyframes spinIcon': {
        from: { transform: 'rotate(0deg)' },
        to: { transform: 'rotate(360deg)' },
    },
    refreshSpinning: {
        animation: '$spinIcon 0.85s linear infinite',
    },
    metaMuted: {
        color: theme.palette.text.secondary,
        fontSize: '0.8125rem',
    },
    toolbarRow: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1.5),
    },
    exitDataFullscreenBtn: {
        position: 'fixed',
        top: theme.spacing(2),
        zIndex: 1300,
        borderRadius: 999,
        padding: theme.spacing(0.85, 2.25),
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.8125rem',
        boxShadow:
            theme.palette.type === 'dark'
                ? '0 4px 24px rgba(0,0,0,0.45)'
                : '0 4px 20px rgba(0,0,0,0.12)',
        border: 'none',
        // Mesma cor do hover do contained primary (primary.dark), também em repouso
        backgroundColor:
            theme.palette.primary.dark || theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        backdropFilter: 'none',
        '&:hover': {
            backgroundColor:
                theme.palette.primary.dark || theme.palette.primary.main,
            boxShadow:
                theme.palette.type === 'dark'
                    ? '0 4px 24px rgba(0,0,0,0.45)'
                    : '0 4px 20px rgba(0,0,0,0.12)',
        },
        '&:active': {
            backgroundColor:
                theme.palette.primary.dark || theme.palette.primary.main,
        },
        ...(theme.direction === 'rtl'
            ? { left: theme.spacing(2) }
            : { right: theme.spacing(2) }),
    },
    fsRoot: {
        height: '100vh',
        maxHeight: '100vh',
        boxSizing: 'border-box',
        paddingTop: 56,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(1.5),
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr)',
        gridAutoRows: 'auto',
        gap: theme.spacing(1.5),
        alignContent: 'start',
        overflow: 'hidden',
        background:
            theme.palette.type === 'dark'
                ? `linear-gradient(165deg, ${theme.palette.grey[900]} 0%, ${theme.palette.background.default} 45%, ${theme.palette.grey[900]} 100%)`
                : `linear-gradient(165deg, ${theme.palette.grey[100]} 0%, ${theme.palette.background.default} 38%, ${theme.palette.grey[50]} 100%)`,
    },
    fsSurface: {
        borderRadius: 14,
        border: `1px solid ${theme.palette.divider}`,
        ...(theme.direction === 'rtl'
            ? {
                  borderRight: `3px solid ${theme.palette.primary.main}`,
              }
            : {
                  borderLeft: `3px solid ${theme.palette.primary.main}`,
              }),
        backgroundColor: theme.palette.background.paper,
        boxShadow:
            theme.palette.type === 'dark'
                ? '0 2px 20px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.04)'
                : '0 2px 16px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.8)',
        overflow: 'hidden',
    },
    fsKpiGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gap: theme.spacing(1.25),
        flexShrink: 0,
        marginBottom: 0,
        padding: theme.spacing(1.25),
        '& .jr-card': {
            borderRadius: 10,
            border: `1px solid ${theme.palette.divider}`,
            boxShadow: 'none',
            backgroundColor:
                theme.palette.type === 'dark'
                    ? 'rgba(255,255,255,0.04)'
                    : theme.palette.grey[50],
            transition: theme.transitions.create(
                ['box-shadow', 'transform', 'border-color'],
                { duration: 180 }
            ),
            '&:hover': {
                boxShadow:
                    theme.palette.type === 'dark'
                        ? '0 4px 14px rgba(0,0,0,0.35)'
                        : '0 4px 14px rgba(0,0,0,0.08)',
                borderColor: `${theme.palette.primary.main}55`,
            },
        },
        '& .jr-card-body h1': {
            fontSize: '1.125rem',
            fontWeight: 700,
            letterSpacing: '-0.02em',
        },
        '& .jr-card-body p': {
            fontSize: '0.65rem',
            lineHeight: 1.35,
            fontWeight: 500,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: theme.palette.text.secondary,
        },
        '& .jr-card-thumb': {
            minWidth: 44,
            width: 44,
            height: 44,
            borderRadius: 10,
        },
        '& .jr-card-thumb i': {
            fontSize: '1.2rem',
        },
    },
    fsChartsSlot: {
        minWidth: 0,
        overflow: 'hidden',
        alignSelf: 'stretch',
        padding: theme.spacing(0.25, 0.25, 0.5),
        '& .row.card-row': {
            marginBottom: '0 !important',
        },
        '& .dash-card': {
            marginBottom: '0 !important',
        },
        '& .jr-card': {
            height: 'auto',
            maxHeight: 'none',
            display: 'flex',
            flexDirection: 'column',
            border: 'none',
            boxShadow: 'none',
            backgroundColor: 'transparent',
        },
        '& .jr-actchart': {
            paddingTop: `${theme.spacing(1.25)}px !important`,
            paddingBottom: `${theme.spacing(0.5)}px !important`,
            paddingLeft: `${theme.spacing(1.5)}px !important`,
            paddingRight: `${theme.spacing(1.5)}px !important`,
        },
        '& .jr-actchart h1.jr-font-weight-bold': {
            fontSize: '0.875rem !important',
            fontWeight: '600 !important',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color: `${theme.palette.text.secondary} !important`,
        },
        '& .jr-actchart .d-flex.mb-2': {
            marginBottom: '6px !important',
        },
        '& .jr-actchart .d-flex.mb-2 + .d-flex': {
            display: 'none !important',
        },
        '& .jr-actchart > p.jr-fs-11': {
            display: 'none',
        },
        '& .area-chart-container .recharts-responsive-container': {
            marginLeft: '0 !important',
            marginBottom: '0 !important',
        },
        '& .up-component': {
            marginTop: '0 !important',
        },
        '& .MuiInputLabel-root': {
            fontSize: '0.75rem',
        },
        '& .MuiSelect-root': {
            fontSize: '0.8125rem',
        },
    },
    fsTableSlot: {
        alignSelf: 'stretch',
        minHeight: 132,
        maxHeight: 220,
        height: '24vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        padding: theme.spacing(1.25, 1.5),
    },
    fsTableCard: {
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        overflow: 'hidden',
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
    },
    fsTableTitle: {
        fontWeight: 700,
        fontSize: '0.8125rem',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.75),
    },
    fsTableCaption: {
        fontSize: '0.7rem',
        fontWeight: 500,
        marginBottom: theme.spacing(0.75),
        opacity: 0.85,
    },
    fsTableScroll: {
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        borderRadius: 10,
        border: `1px solid ${theme.palette.divider}`,
        '& table': {
            fontSize: '0.74rem',
            marginBottom: 0,
        },
        '& thead th': {
            fontWeight: 700,
            fontSize: '0.62rem',
            textTransform: 'uppercase',
            letterSpacing: '0.07em',
            color: theme.palette.text.secondary,
            borderBottom: `2px solid ${theme.palette.divider}`,
            backgroundColor:
                theme.palette.type === 'dark'
                    ? 'rgba(255,255,255,0.06)'
                    : theme.palette.grey[100],
            padding: theme.spacing(0.75, 0.75),
        },
        '& tbody td': {
            padding: theme.spacing(0.6, 0.75),
            verticalAlign: 'middle',
            borderColor: theme.palette.divider,
        },
        '& tbody tr': {
            transition: 'background-color 0.12s ease',
        },
        '& tbody tr:nth-of-type(even)': {
            backgroundColor:
                theme.palette.type === 'dark'
                    ? 'rgba(255,255,255,0.02)'
                    : 'rgba(0,0,0,0.02)',
        },
        '& tbody tr:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    fsErrorLine: {
        flexShrink: 0,
        fontSize: '0.75rem',
        lineHeight: 1.4,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        padding: theme.spacing(0.75, 1.25),
        borderRadius: 10,
        border: `1px solid ${theme.palette.error.main}44`,
        backgroundColor:
            theme.palette.type === 'dark'
                ? 'rgba(244, 67, 54, 0.12)'
                : 'rgba(244, 67, 54, 0.08)',
        color: theme.palette.error.main,
        fontWeight: 500,
    },
    fsWarnLine: {
        flexShrink: 0,
        fontSize: '0.75rem',
        lineHeight: 1.4,
        padding: theme.spacing(0.75, 1.25),
        borderRadius: 10,
        border: `1px solid ${theme.palette.warning.main}55`,
        backgroundColor:
            theme.palette.type === 'dark'
                ? 'rgba(255, 167, 38, 0.12)'
                : 'rgba(255, 167, 38, 0.1)',
        color: theme.palette.text.primary,
        fontWeight: 500,
    },
    fsOuterClamp: {
        maxHeight: '100vh',
        overflow: 'hidden',
    },
}));

export default useCleaningReportPluginspaceStyles;
